import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { FYIDocument } from '../types/fyi-docs';

type Config = {
    fyiEntityId: number;
    fyiCabinetId: number;
    page: number;
    limit: number;
    name?: string;
};

async function getFYIDocuments(config: Config): Promise<{ documents: { exists: boolean; document: FYIDocument }[]; totalItems: number }> {
    const { data } = await api.get('/fyi-docs/documents', {
        params: {
            ...config,
        },
    });
    return data;
}

export function useFYIDocuments({
    fyiCabinetId,
    fyiEntityId,
    page,
    limit,
    name,
}: Config): UseQueryResult<{ documents: { exists: boolean; document: FYIDocument }[]; totalItems: number }, unknown> {
    return useQuery(
        ['fyi', 'documents', fyiEntityId, fyiCabinetId, page, limit, name],
        () => getFYIDocuments({ fyiCabinetId, fyiEntityId, page, limit, name }),
        {
            keepPreviousData: true,
        }
    );
}
